import { useEffect } from 'react';
import { setBreadcrumbs } from '@app/redux/features/breadcrumbsSlice';
import { BreadCrumbIcon, BreadCrumbType } from '@entities/util/IBreadCrumb';
import { useDispatch } from 'react-redux';

function useAccountBreadcrumbs(account: any) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!account) return;

    dispatch(
      setBreadcrumbs([
        {
          title: 'Sales DB',
          type: BreadCrumbType.LINK,
          link: '/main',
          icon: BreadCrumbIcon.VIA_BTC,
        },
        {
          title: 'Обзор аккаунтов',
          type: BreadCrumbType.LINK,
          link: '/account',
        },
        { title: `${account?.account}`, type: BreadCrumbType.TEXT },
      ])
    );
  }, [account?.account]);
}

export default useAccountBreadcrumbs;
